<template>
    <v-dialog v-model="mostrar" persistent max-width="70vw" scrollable>
		<v-card max-height="600px">
			<v-toolbar flat :color="this.$store.state.title == 'Calendario' ? this.$store.state.corEvento : cor"></v-toolbar>
			<v-divider></v-divider>
            <v-card-text>
            <v-container>
                <v-row>
                    <v-col cols="12">
                        <v-text-field label="Nome" v-model="cla.nome_cla" outlined></v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-menu ref="abrirDtInicio" v-model="abrirDtInicioPicker" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
						    <template v-slot:activator="{ on }">
							    <v-text-field label="Data Inicio" v-model="dataInicioFormatada" v-on="on" outlined></v-text-field>
						    </template>
						    <v-date-picker locale="pt-br" v-model="dataInicio" no-title @input="abrirDtInicioPicker = false"></v-date-picker>
					    </v-menu>
                    </v-col>
                    <v-col cols="12">
			            <v-select item-text="text" item-value="value" :items="this.mestres" v-model="cla.id_mestre" label="Mestre" outlined></v-select>
                    </v-col>
                    <v-col cols="12">
			            <v-select item-text="text" item-value="value" :items="this.casas" v-model="cla.casa" label="Casa" outlined></v-select>
                    </v-col>
                </v-row>
            </v-container>
            </v-card-text>
            <v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="primary" @click.stop="salvar()">Salvar</v-btn>
				<v-btn text color="primary" @click.stop="fechar()">Fechar</v-btn>
			</v-card-actions>
		</v-card>
    </v-dialog>    
</template>

<script>
import Br from '@/config/barramento.js'
import metodos from '@/mixins/metodos'
// import { mapState } from 'vuex'
import { baseApiUrl, showError, showSuccess } from "@/config/global"
import axios from 'axios'


export default {
    name: 'cla',
    mixins: [metodos],
    components:{
        
    },
    data(){
        return{
            cor: 'primary',
            mostrar: false,
            cla: {},
            abrirDtInicioPicker: false,
            abrirDtFimPicker: false,
            dataInicio: '',
            dataInicioFormatada: '',
            mestres: [],
            casas: [
					{value: 'M', text: 'Masculino'},
					{value: 'F', text: 'Feminino'}
				],
        }
    },

    methods:{
        salvar(){
            const url = `${baseApiUrl}/Cadastros/clas/update.php`
					
					if(this.cla.nome_cla && this.cla.inicioObj && this.cla.id_mestre && this.cla.casa){

						axios.post(url, this.cla)
						.then(res => {
							if(res.data.codigo == '01'){
                                showSuccess(res.data.mensagem)
                                Br.setClaAtualizado(this.cla)
                                this.cla = {}
                                this.mostrar = false
							}else{
								showError(res.data.mensagem)
							}
						})
					}else{
						showError("Todos os campos devem ser preenchidos!")
                    }
        },

        buscaMestres(){
				const url = `${baseApiUrl}/Cadastros/clas/readMestres.php`

				axios.get(url).then(res => {

					if(res.data.codigo == '01'){
						this.mestres = res.data.dados.map(c => {

							return{
								...c,
							}
						})
					}
					if(this.cla.id){
						this.mestres.unshift({value: this.cla.id_mestre, text: this.cla.nome_mestre})	
                    }
                    
                    this.mostrar = true
					
				})
            },
            
        fechar(){
            this.mostrar = false
        }
    },

    created(){
        
        Br.onEditarCla(cla => {
            this.buscaMestres()
            this.cla = cla
            this.dataInicioFormatada = this.formataDateBr(this.cla.inicioObj.toISOString().substr(0, 10))
            
        })
    },

    watch:{
        dataInicio(val){
				this.dataInicioFormatada = this.formataDateBr(this.dataInicio)
				this.cla.inicioObj = this.converterData(this.dataInicio)
        },

        'cla.id_mestre'(val){

                this.mestres.forEach(v => {
        
                    if(v.value == val){
                        this.cla.nome_mestre = v.text
                    }
                })
                
            
        }

    }
}
</script>

<style scoped>

</style>